module.exports = __webpack_public_path__ + "static/mdm_word-dd0877b0603bb4a3cc24e6bd78ff6ec9.png";